export const UPSC_FAQ_ITEMS_CMS_API_PATH = 'upsc-faq-items';

export const UPSC_FAQ_SESSION_KEYS = [
  'homeFaq',
  'todayAnalysisFaq',
  'subjectWiseFaq',
  'quizFaq',
  'detailedArticlePage'
];

const normalizeFaqItem = (item) => {
  if (!item || typeof item !== 'object') {
    return null;
  }
  const faqQuestion = item.faqQuestion.trim();
  const faqAnswer = item.faqAnswer.trim();

  if (!faqQuestion) {
    return null;
  }

  return {
    id: item.id,
    faqQuestion,
    faqAnswer: faqAnswer ?? ''
  };
};

const normalizeFaqSession = (session) => {
  if (!session || typeof session !== 'object') {
    return undefined;
  }

  const faqSession = Array.isArray(session.faqItems)
    ? session.faqItems.map(normalizeFaqItem).filter(Boolean)
    : [];

  if (!session.faqHeading && !faqSession.length) {
    return undefined;
  }

  return {
    faqHeading: session.faqHeading ?? '',
    faqSession
  };
};

export const normalizeUpscFaqItemsResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return {};
  }

  return UPSC_FAQ_SESSION_KEYS.reduce((normalized, sessionKey) => {
    const session = normalizeFaqSession(data[sessionKey]);

    if (!session) {
      return normalized;
    }

    return {
      ...normalized,
      [sessionKey]: session
    };
  }, {});
};
